export default "__VITE_ASSET__BOAo7KGJ__"